export const CREATE_COMPANY_SUBSCRIPTION_PUBLIC_START =
  'CREATE_COMPANY_SUBSCRIPTION_PUBLIC_START';
export const CREATE_COMPANY_SUBSCRIPTION_PUBLIC_SUCCESS =
  'CREATE_COMPANY_SUBSCRIPTION_PUBLIC_SUCCESS';
export const CREATE_COMPANY_SUBSCRIPTION_PUBLIC_FAIL =
  'CREATE_COMPANY_SUBSCRIPTION_PUBLIC_FAIL';

export const CANCEL_COMPANY_SUBSCRIPTION_START =
  'CANCEL_COMPANY_SUBSCRIPTION_START';
export const CANCEL_COMPANY_SUBSCRIPTION_SUCCESS =
  'CANCEL_COMPANY_SUBSCRIPTION_SUCCESS';
export const CANCEL_COMPANY_SUBSCRIPTION_FAIL =
  'CANCEL_COMPANY_SUBSCRIPTION_FAIL';

export const RESET_COMPANY_SUBSCRIPTION_STORE =
  'RESET_COMPANY_SUBSCRIPTION_STORE';

export type CompanySubscriptionActionTypes =
  | typeof CREATE_COMPANY_SUBSCRIPTION_PUBLIC_START
  | typeof CREATE_COMPANY_SUBSCRIPTION_PUBLIC_SUCCESS
  | typeof CREATE_COMPANY_SUBSCRIPTION_PUBLIC_FAIL
  | typeof CANCEL_COMPANY_SUBSCRIPTION_START
  | typeof CANCEL_COMPANY_SUBSCRIPTION_SUCCESS
  | typeof CANCEL_COMPANY_SUBSCRIPTION_FAIL
  | typeof RESET_COMPANY_SUBSCRIPTION_STORE;
